let baseURL = '/api'
const url = window.location.href
const port = window.location.port;
let imgUrl
let browserUrl // 退出登录
if (url.indexOf('online') !== -1) {
    imgUrl = 'static'
} else {
    imgUrl = '/static'
}
let socketUrl
// 开发环境
if (url.indexOf('192.168.6.186') !== -1 || url.indexOf('devonline.fefsfc.com') !== -1) {
    browserUrl = 'http://192.168.6.186:8858/#/usercenter/login'
    socketUrl = 'ws://192.168.6.186:8859/api/8710/ScreenCtl'

    // 测试环境
} else if (url.indexOf('192.168.6.178') !== -1) {
    browserUrl = 'http://192.168.6.178/#/usercenter/login'
    socketUrl = 'ws://192.168.6.178:8859/api/8710/ScreenCtl'

    // 准生产环境
} else if (url.indexOf('uat-word.fefsfc.com') !== -1) {
    browserUrl = 'https://uat-user.fefsfc.com:6443/#/usercenter/login'
    socketUrl = 'wss://uat-word.fefsfc.com:6443/api/8710/ScreenCtl'

    // 生产环境
} else if (url.indexOf('word.fefsfc.com') !== -1) {
    browserUrl = 'https://user.fefsfc.com/#/usercenter/login'
    socketUrl = 'wss://word.fefsfc.com/api/8710/ScreenCtl'

    // 本地
} else if (url.indexOf('150') !== -1) {
    browserUrl = 'http://192.168.6.150:8099/#/usercenter/login'
    socketUrl = 'ws://192.168.6.186:8859/api/8710/ScreenCtl'
} else if (url.indexOf('192.168.6.239') !== -1) {
    browserUrl = 'http://192.168.6.239:8080'
    socketUrl = 'ws://192.168.6.239:8859/api/8710/ScreenCtl'
} else if (url.indexOf('192.168.6.122') !== -1) {
    browserUrl = 'http://192.168.6.122:8080'
    socketUrl = 'ws://192.168.6.122:8859/api/8710/ScreenCtl'
} else if (url.indexOf('testword.idechat.com') !== -1) {
    browserUrl = 'https://testwww.idechat.com'
    socketUrl = 'wss://testword.idechat.com/api/8710/ScreenCtl'
} else if (url.indexOf('word.idechat.com') !== -1) {
    browserUrl = 'https://www.idechat.com'
    socketUrl = 'wss://word.idechat.com/api/8710/ScreenCtl'
} else if (url.indexOf('word.ideaigc.com') !== -1) {
    browserUrl = 'https://www.ideaigc.com'
    socketUrl = 'wss://word.ideaigc.com/api/8710/ScreenCtl'
} else if (url.indexOf('localhost') !== -1) {
    browserUrl = `http://localhost:${port}/#/login`
} else if (url.indexOf('218') !== -1) {
    browserUrl = 'http://10.162.26.218:8080'
    socketUrl = 'ws://10.162.26.218:8859/api/8710/ScreenCtl'
} else if (url.indexOf('192.168.140.22') !== -1) {
    browserUrl = 'http://192.168.140.22:8080'
    socketUrl = 'ws://192.168.140.22:8859/api/8710/ScreenCtl'
} else {
    browserUrl = 'http://192.168.6.174:8099/#/usercenter/login'
    socketUrl = 'ws://192.168.6.186:8859/api/8710/ScreenCtl'
}

export {imgUrl, baseURL, socketUrl, browserUrl}
